import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { MatSelectionList, MatListOption } from "@angular/material/list";
import { VisitType } from "@app/models/rest/visit-type";
import { VisitTypeResourceStore } from "@app/services/store/visit-type-resource-store";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { SkillProfile } from "@app/models/rest/skill-profile";
import { VisitTypeResource } from "@app/models/rest/visit-type-resource";
import { SkillProfileStore } from "@app/services/store/skill-profile-store";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { AsyncPipe } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
import { DialogHeaderComponent } from "../../../shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-visit-type-skill-profile-add",
  templateUrl: "./visit-type-skill-profile-add.component.html",
  styleUrls: ["./visit-type-skill-profile-add.component.css"],
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatSelectionList,
    MatListOption,
    MatDialogActions,
    MatButton,
    AsyncPipe,
    TranslatePipe,
    DialogHeaderComponent
  ]
})
export class VisitTypeSkillProfileAddComponent implements OnInit {
  visitTypeResourceStore = inject(VisitTypeResourceStore);
  skillProfileStore = inject(SkillProfileStore);
  dialogRef =
    inject<MatDialogRef<VisitTypeSkillProfileAddComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  visitType: VisitType;
  @ViewChild("skillProfileSelect", { static: false })
  skillProfileSelect: MatSelectionList;
  availableList: SkillProfile[] = [];

  constructor() {
    const data = this.data;

    this.visitType = data.resource;
  }

  ngOnInit() {
    this.skillProfileStore
      .loadAll({ params: { projection: "detail" } }, true)
      .then((value) => {
        this.availableList = value.resources as unknown as SkillProfile[];
      });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSelectClick() {
    console.log("select");
    console.log(this.skillProfileSelect.selectedOptions.selected);

    const selected = this.skillProfileSelect.selectedOptions.selected;
    if (selected.length === 0) {
      this.dialogRef.close();
      return;
    }

    const createPromises = selected.map((selectedSkillProfile) => {
      const visitTypeResource: VisitTypeResource = new VisitTypeResource();
      visitTypeResource.visitType = this.visitType;
      visitTypeResource.skillProfile = selectedSkillProfile.value;
      return new Promise<void>((resolve, reject) => {
        this.visitTypeResourceStore.create(visitTypeResource).subscribe({
          next: (value) => {
            console.log(value);
            resolve();
          },
          error: (error) => {
            console.log(error);
            reject(error);
          }
        });
      });
    });

    Promise.all(createPromises)
      .then(() => {
        this.dialogRef.close(true); // Pass true to indicate resources were created
      })
      .catch((error) => {
        console.log("error");
        console.log(error);
        alert(error.error?.message || error.message || "An error occurred");
        this.dialogRef.close();
      });
  }
}
